
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/autor/[author]",
      function () {
        return require("private-next-pages/blog/autor/[author]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/autor/[author]"])
      });
    }
  